import { useAlerts } from '../../contexts/AlertContext';
import { Alert } from '../../models/alert';
import './alert-container.css';

export function AlertContainer({ children }: { children: React.ReactNode }) {
    const { alerts, removeAlert } = useAlerts();

    return (
        <div className="alert-container-wrapper">
            <div className="alert-container">
                {alerts.map((alert: Alert) => (
                    <div key={alert.id} className={`alert alert-${alert.type}`}>
                        <div className="alert-content">
                            <p>{alert.message}</p>
                        </div>
                        {alert.dismissible && (
                            <button
                                className="alert-close"
                                onClick={() => removeAlert(alert.id)}
                                aria-label="Close alert"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                ))}
            </div>
            {children}
        </div>
    );
}
